import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { SupplyHistory } from "./meterpointSupplyHistory"
import { ISupplyHistory } from "./meterpointSupplyHistory.types"
import type { GetMeterpointSupplyHistoryQuery } from "@/api/hasura/generated/graphql"

export type ISupplyHistoryRaw =
  GetMeterpointSupplyHistoryQuery["meter_point_history"][number]

export const MeterpointSupplyHistoryParser: IParser<
  ISupplyHistory[],
  ISupplyHistoryRaw[]
> = {
  toDomain: (data: ISupplyHistoryRaw[]) => {
    try {
      return data.map((value: ISupplyHistoryRaw) => {
        return new SupplyHistory(
          value.id,
          dayjs(value.created_at),
          value.event_type,
          value.status,
        )
      })
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
